import React, { useState, useEffect, useRef } from "react";
import mail from "../../assets/images/mail.svg";
import notifications from "../../assets/images/notifications.svg";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import { APP_ROUTES } from "../../routes/approutes";
import { useHistory } from "react-router-dom";
import Notifications from "./notifications";
import Email from "../ProfileScreen/Email";
import { Sidebar } from "primereact/sidebar";
import { InputTextarea } from "primereact/inputtextarea";
import notificationScreens from "../../services/profileScreen/notificationScreens";
import { Toast } from "primereact/toast";

function Header() {
  const settings = [
    { name: "Profile", path: APP_ROUTES.PROFILESCREEN },
    { name: "Feedback" },
    { name: "Logout", path: "/" },
  ];

  const userObj = JSON.parse(localStorage.getItem("loginObj")) || {};
  const history = useHistory();
  const [anchorElUser, setAnchorElUser] = useState(null);
  const [showNotifications, setShowNotifications] = useState(false);
  const [showEmails, setShowEmails] = useState(false);
  const [showSidebar, setShowSidebar] = useState(false);
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");
  const [liveTime, setLiveTime] = useState("");
  const toastRef = useRef(null);

  const testParam = userObj.user?.code;
  const userFirstName = userObj.user?.firstName || "";
  const userLastName = userObj.user?.lastName || "";
  const userMobile = userObj.user?.mobile || "";

  const handleMenuItemClick = (path, name) => {
    handleCloseUserMenu();
    
    if (name === 'Logout') {
      localStorage.clear();
    }
    
    if (path === APP_ROUTES.PROFILESCREEN) {
      history.push(path);
    } else if (name === 'Feedback') {
      setShowSidebar(true);
    } else if (name === 'Logout') {
      history.push(path || "/");
    }
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const toggleNotifications = () => {
    setShowNotifications(!showNotifications);
  };

  const toggleEmails = () => {
    setShowEmails(!showEmails);
  };

  const getCurrentTime = () => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const date = String(currentDate.getDate()).padStart(2, "0");
    const hours = String(currentDate.getHours()).padStart(2, "0");
    const minutes = String(currentDate.getMinutes()).padStart(2, "0");
    const seconds = String(currentDate.getSeconds()).padStart(2, "0");

    const formattedTime = `${year}-${month}-${date} ${hours}:${minutes}:${seconds}`;
    setLiveTime(formattedTime);
  };

  const showSuccess = (message) => {
    toastRef.current?.show({
      severity: "success",
      summary: "Success",
      detail: message,
      life: 3000,
    });
  };

  const showError = (message) => {
    toastRef.current?.show({
      severity: "error",
      summary: "Error",
      detail: message,
      life: 3000,
    });
  };

  useEffect(() => {
    const timerID = setInterval(() => getCurrentTime(), 1000);

    return () => {
      clearInterval(timerID);
    };
  }, []);

  const sendFeedback = () => {
    if (!subject?.trim()) {
      showError("Subject is required");
      return;
    }

    if (!body?.trim()) {
      showError("Message body is required");
      return;
    }

    const payload = {
      subject: subject.trim(),
      content: body.trim(),
      modifiedDate: liveTime,
      modifiedBy: testParam,
      createdDate: liveTime,
      createdBy: testParam,
      fromCode: testParam,
      status: 1,
    };

    notificationScreens
      .sendFeedBack(payload)
      .then((res) => {
        if (res?.data?.responseCode === '200') {
          setSubject("");
          setBody("");
          showSuccess("Feedback Sent Successfully");
          setShowSidebar(false);
        } else {
          showError(res?.data?.message || "Failed to send feedback");
        }
      })
      .catch((error) => {
        let errorMessage = "Error sending feedback";
        if (error.response?.data) {
          const errorData = error.response.data;
          errorMessage = errorData.message || errorMessage;
          if (errorData.details?.[1]) {
            errorMessage += `: ${errorData.details[1]}`;
          }
        }

        showError(errorMessage);
      });
  };

  const handleSidebarClose = () => {
    setShowSidebar(false);
    setSubject("");
    setBody("");
  };

  return (
    <>
      <Toast ref={toastRef} />
      
      <Sidebar
        visible={showSidebar}
        position="right"
        onHide={handleSidebarClose}
        className="w-[500px]"
      >
        <h2 className="font-bold text-2xl leading-6 tracking-normal text-left text-[#262626]">
          Feedback
        </h2>

        <div className="flex flex-col">
          <label
            htmlFor="subject-input"
            className="block text-sm font-medium text-black font-medium mb-4 mt-8"
          >
            Subject
          </label>
          <InputTextarea
            id="subject-input"
            value={subject}
            placeholder="Type Here ......"
            rows={2}
            cols={2}
            onChange={(e) => setSubject(e.target.value)}
            className="border rounded border-solid border-[#E2E2E2] box-border w-full pl-3 pr-10"
          />
        </div>
        <div className="flex flex-col">
          <label
            htmlFor="message-input"
            className="block text-sm font-medium text-black font-medium mb-4 mt-8"
          >
            Message
          </label>
          <InputTextarea
            id="message-input"
            value={body}
            placeholder="Type Here ......"
            rows={10}
            cols={30}
            onChange={(e) => setBody(e.target.value)}
            className="border rounded border-solid border-[#E2E2E2] box-border w-full pl-3 pr-10"
          />
        </div>
        <button
          className="w-64 h-10 border border-[#004172] bg-[#004172] text-white font-bold rounded-md mt-6 ml-20 hover:bg-[#00315a] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          onClick={sendFeedback}
          disabled={!subject.trim() || !body.trim()}
        >
          Send
        </button>
      </Sidebar>
      
      <div className="bg-white w-[87%] rounded-tl-3xl rounded-tr-none rounded-br-none rounded-bl-none shadow-[0px_8px_18px_0px_rgba(0,0,0,0.078)] p-4 fixed">
        <div className="flex flex-row">
          <div className="flex items-center ml-auto mr-4 mt-4">
            <button
              className="mr-4 bg-transparent border-none p-0 cursor-pointer"
              onClick={toggleEmails}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  toggleEmails();
                }
              }}
              aria-label="Open emails"
              type="button"
            >
              <img
                src={mail}
                alt=""
                aria-hidden="true"
                className="w-6 h-6"
              />
            </button>
            <button
              className="mr-4 bg-transparent border-none p-0 cursor-pointer"
              onClick={toggleNotifications}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  toggleNotifications();
                }
              }}
              aria-label="Open notifications"
              type="button"
            >
              <img
                src={notifications}
                alt=""
                aria-hidden="true"
                className="w-6 h-6"
              />
            </button>
            <Box sx={{ flexGrow: 0 }}>
              <Tooltip title="Open settings">
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                  <Avatar alt="User Avatar" src="/static/images/avatar/2.jpg" />
                </IconButton>
              </Tooltip>
              <Menu
                sx={{ mt: "45px" }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >
                {settings.map((setting) => (
                  <MenuItem
                    key={setting.name}
                    onClick={() => handleMenuItemClick(setting.path, setting.name)}
                  >
                    <Typography textAlign="center">{setting.name}</Typography>
                  </MenuItem>
                ))}
              </Menu>
            </Box>
            <div className="flex flex-col">
              <h1 className="ml-2 font-medium text-primary text-bold">
                {userFirstName} {userLastName}
              </h1>
              <h1 className="ml-2 font-medium font-mono">
                {userMobile}
              </h1>
            </div>
          </div>
        </div>
      </div>
      
      <Notifications show={showNotifications} setShow={setShowNotifications} />
      <Email show={showEmails} setShow={setShowEmails} />
    </>
  );
}

export default Header;